import { Controller } from "@hotwired/stimulus"

// Slide-out admin sidebar for small screens. The sidebar is a static flex child
// on md+; on mobile it starts off-canvas (-translate-x-full) and open/close slide
// it in/out along with a backdrop. Closes on backdrop click or Escape.
//
// NB: only idempotent actions (open/close) are exposed — NOT a toggle. The admin
// layout loads two JS bundles (app + admin), each starting its own Stimulus
// Application, so every action handler fires twice. open()/close() are safe under
// a double-fire; a toggle would flip twice and no-op.
export default class extends Controller {
  static targets = ["panel", "backdrop"]

  connect() {
    this.onKeydown = (event) => { if (event.key === "Escape") this.close() }
    document.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown)
  }

  open() {
    // `invisible` (visibility:hidden) keeps the closed drawer out of the tab order
    // and a11y tree on mobile; remove it to reveal, slide in via the transform.
    this.panelTarget.classList.remove("-translate-x-full", "invisible")
    this.backdropTarget.classList.remove("hidden")
  }

  close(event) {
    if (event) event.preventDefault()
    this.panelTarget.classList.add("-translate-x-full", "invisible")
    this.backdropTarget.classList.add("hidden")
  }
}
